// cornerstoneInit.js
// Lightweight Cornerstone3D initialization — core + tools only.
// The DICOM image-loader (and its .external assignments) is initialized
// lazily inside DICOMViewer.jsx when the viewer opens, avoiding the
// "Cannot set properties of undefined" error caused by CRA's module
// bundling order for @cornerstonejs/dicom-image-loader.

import { init as csRenderInit } from '@cornerstonejs/core';
import { init as csToolsInit  } from '@cornerstonejs/tools';

let initialized = false;

export async function initCornerstone() {
  if (initialized) return;
  try {
    await csRenderInit();
    await csToolsInit();
    initialized = true;
    console.log('[cornerstoneInit] initialized successfully');
  } catch (err) {
    console.error('[cornerstoneInit] failed:', err);
  }
}

export function isCornerstoneInitialized() {
  return initialized;
}
